import { IAudioSetsItem } from '../../models/AudioSetsItemModel';

export const AUDIO_DOING = 1;
export const AUDIO_REVIEWING = 2;
export const AUDIO_DONE = 3;
export const AUDIO_REJECTED = 4;

/** Finds the next pending review, wrapping once at the end of the set. */
export const findNextPendingIndex = (items: IAudioSetsItem[], currentIndex: number): number => {
  for (let offset = 1; offset <= items.length; offset++) {
    const index = (currentIndex + offset) % items.length;
    if (items[index].status === AUDIO_REVIEWING) {
      return index;
    }
  }

  return -1;
};
